import React from "react";

const AadharCard = (props) => {
  const isAadharVerified = props.$store?.user?.is_aadhar_verified;
  return (
    <div className="card profile_card">
      <div className="card-header border-0">
        <div className="d-flex align-items-center">
          <div className="img_outer">
            <img src={imagepaths.aadharIcon} alt="aadhar" />
          </div>
          <h5 className="title ms-2">Aadhar</h5>
        </div>
        <div
          className={Object.className({
            "action_box d-flex align-items-center": true,
          })}
        >
          {isAadharVerified ? (
            <i className="fa fa-check check_icon"></i>
          ) : (
            <button onClick={(...args) => props.onEdit(...args, "aadhar")}>
              <i className="fa fa-pencil"></i>
            </button>
          )}
        </div>
      </div>
      <div className="card-body">
        <h5>Aadhar no</h5>
        <p>{props?.aadhardata?.uid || "-"}</p>
        <h5>Address</h5>
        <p>
          {/* House no. 49, Vivekananda colony, Badangpet, Hyderabad */}
          {props?.aadhardata?.address || "-"}
        </p>
      </div>
    </div>
  );
};

export default constore(AadharCard);
